export const commonMutations = {
    /** Запись текущей ширины экрана
     * @param state хранилище
     * @param width передаваемое значение ширины
     */
    writeWindow(state, width) {
        state.window = width;
    },
    openInfoModal(state, data) {
        state.infoModal = { openModal: true, text: data.text, type: data.type };
    },
    closeInfoModal(state) {
        state.infoModal = {
            openModal: false,
            text: "",
            type: "",
        };
    },
    toggleShowUpdateInfoModal(state, bool) {
        state.showUpdateInfoModal = bool;
    },
    changeIsRu(state, data) {
        state.isRu = data;
    },
    changeMode(state, data) {
        state.mode = data;
    },
    handleShowExcludedBanksList(state, isShow) {
        state.showExcludedBanksList = isShow;
    },
    handleShowTemplateTitleModal(state, data) {
        state.showTemplateTitleModal = data || !state.showTemplateTitleModal;
    },
    updateEyeView(state, data) {
        state.eyeView = data || !state.eyeView;
    },
    handleShowDownloadModal(state, data) {
        state.showDownloadModal = data || !state.showDownloadModal;
    },
};
